import styled from"@emotion/styled";import{Table}from"@wp/src/components/common";import{Body1W500Neutral800,CardTitle}from"@wp/src/components/common/atoms";export const PortfolioTitleContainer=styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
`;export const PortfolioCardTitle=styled(CardTitle)``;export const PortfolioPercentileRank=styled.div`
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: ${props=>props.theme.colors[props.colorCode]};

  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 3px;

  border-radius: 8px;
  background-color: ${props=>props.theme.colors.white};
  padding: 4px 8px;
  min-width: 100px;
  height: 32px;
  box-sizing: border-box;
  text-align: center;
  border: 2px solid ${props=>props.theme.colors.neutral200};
`;export const CashHoldingsContainer=styled.div`
  padding-bottom: 24px;
`;export const CashContainer=styled(Body1W500Neutral800)`
  display: flex;
  align-items: center;
`;export const StyledOrderExecutionListTable=Table;export const StyledContentContainer=styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;